import { axios } from "util/request";

// eslint-disable-next-line import/prefer-default-export
export const fetchUserRoleList = (userID: number) => {
  const url = `/role/user/${userID}`;
  return axios.get(url);
};
